import { RegexUtil } from './regex-util';

export  class IdentificationCodeUtil {

    public static isValid = (value) => new RegExp(RegexUtil.IDENTIFICATION_CODE).test(value);

}
